import { TSendTaskMakeAnAppointment, TNewStatus } from './models';
import API from '../api';
import { TMessageItem } from '../messages/models';

const PATH_ASSIGNEMEVTS = '/Assignments';

const sendAssignmentMakeAnAppointment = (task: TSendTaskMakeAnAppointment) =>
  API.post<TMessageItem>(`${PATH_ASSIGNEMEVTS}/make-an-appointment`, task).then(result => result);

const updateStatus = (newStatus: TNewStatus) => API.patch(`${PATH_ASSIGNEMEVTS}/update-status`, newStatus);

export { sendAssignmentMakeAnAppointment, updateStatus };
